module.exports = __webpack_public_path__ + "static/media/3.6bb47235.jpg";